import CurrentStateMessage from "./CurrentStateMessage";

const messages = {
  CurrentStateMessage
};

export { messages };
